// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/Pages/ProfilePage/ProfilePage.module.scss */
.ProfilePage_wrap__Wkl4s {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 16px;
  background: #ffffff;
}

.ProfilePage_card__4GZHL {
  width: 100%;
  max-width: 420px;
  padding: 20px;
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.ProfilePage_title__Eai-O {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #222;
  text-align: center;
}

.ProfilePage_subtitle__CF8Le {
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
  color: #666;
  text-align: center;
}

.ProfilePage_error__LU5m6 {
  margin: 0;
  font-size: 13px;
  color: #e50040;
  text-align: center;
}

.ProfilePage_actions__ItzZX {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.ProfilePage_btn__KYy7f {
  width: 280px;
  max-width: 100%;
  border-radius: 100px;
  border: none;
  background: #e50040;
  color: #fff;
  font-size: 16px;
  line-height: 26px;
  font-weight: 600;
  padding: 15px 20px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(229, 0, 64, 0.22);
}

.ProfilePage_btn__KYy7f:hover:not(:disabled) {
  opacity: 0.95;
}

.ProfilePage_btn__KYy7f:disabled {
  background: #f2f2f5;
  color: #a0a0b0;
  cursor: default;
  box-shadow: none;
}

.ProfilePage_secondaryBtn__3FD-O {
  border: 1px solid #e50040;
  background: #fff;
  color: #e50040;
  box-shadow: none;
}

.ProfilePage_secondaryBtn__3FD-O:disabled {
  border-color: #e0e0e6;
}

@media (max-width: 420px) {
  .ProfilePage_card__4GZHL {
    padding: 16px;
  }
  .ProfilePage_title__Eai-O {
    font-size: 20px;
  }
  .ProfilePage_btn__KYy7f {
    width: 100%;
    font-size: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/ProfilePage/ProfilePage.module.scss"],"names":[],"mappings":"AAAA,kDAAA;AACA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,6CAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE;IACE,aAAA;EACF;EAEA;IACE,eAAA;EAAF;EAGA;IACE,WAAA;IACA,eAAA;EADF;AACF","sourcesContent":["/* src/Pages/ProfilePage/ProfilePage.module.scss */\r\n.wrap {\r\n  min-height: 100vh;\r\n  display: grid;\r\n  place-items: center;\r\n  padding: 16px;\r\n  background: #ffffff;\r\n}\r\n\r\n.card {\n  width: 100%;\n  max-width: 420px;\n  padding: 20px;\n  border-radius: 18px;\n  background: #fff;\r\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.08);\r\n  border: 1px solid #f0f0f0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #222;\n  text-align: center;\n}\n\n.subtitle {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #666;\n  text-align: center;\n}\n\n.error {\n  margin: 0;\n  font-size: 13px;\n  color: #e50040;\n  text-align: center;\n}\n\n.actions {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n}\n\n.btn {\n  width: 280px;\n  max-width: 100%;\n  border-radius: 100px;\n  border: none;\n  background: #e50040;\n  color: #fff;\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: 600;\n  padding: 15px 20px;\n  cursor: pointer;\n  box-shadow: 0 6px 16px rgba(229, 0, 64, 0.22);\n}\n\n.btn:hover:not(:disabled) {\n  opacity: 0.95;\n}\n\n.btn:disabled {\n  background: #f2f2f5;\n  color: #a0a0b0;\n  cursor: default;\n  box-shadow: none;\n}\n\n.secondaryBtn {\n  border: 1px solid #e50040;\n  background: #fff;\n  color: #e50040;\n  box-shadow: none;\n}\n\n.secondaryBtn:disabled {\n  border-color: #e0e0e6;\n}\n\r\n@media (max-width: 420px) {\r\n  .card {\r\n    padding: 16px;\r\n  }\r\n\n  .title {\n    font-size: 20px;\n  }\n\n  .btn {\n    width: 100%;\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ProfilePage_wrap__Wkl4s`,
	"card": `ProfilePage_card__4GZHL`,
	"title": `ProfilePage_title__Eai-O`,
	"subtitle": `ProfilePage_subtitle__CF8Le`,
	"error": `ProfilePage_error__LU5m6`,
	"actions": `ProfilePage_actions__ItzZX`,
	"btn": `ProfilePage_btn__KYy7f`,
	"secondaryBtn": `ProfilePage_secondaryBtn__3FD-O`
};
export default ___CSS_LOADER_EXPORT___;
